export var LeadTypeEnum;
(function (LeadTypeEnum) {
    LeadTypeEnum["Ambassarors"] = "ambassadors_list";
    LeadTypeEnum["Content"] = "content";
    LeadTypeEnum["LiveStreams"] = "live_streams";
    LeadTypeEnum["FAQ"] = "faq";
    LeadTypeEnum["GroupChat"] = "group_chat";
    LeadTypeEnum["SingleChat"] = "single_chat";
})(LeadTypeEnum || (LeadTypeEnum = {}));
export var getLeadTypePath = function (data) {
    var type = data.type, groupChatId = data.groupChatId, groupChatPrivateCode = data.groupChatPrivateCode, ambassadorId = data.ambassadorId, isAutorized = data.isAutorized;
    var path = '/';
    var action = '';
    switch (type) {
        case LeadTypeEnum.Ambassarors:
            path = '/chat-to-us';
            break;
        case LeadTypeEnum.Content:
            path = '/posts';
            break;
        case LeadTypeEnum.LiveStreams:
            path = '/live-streams';
            break;
        case LeadTypeEnum.FAQ:
            path = '/faq';
            break;
        case LeadTypeEnum.GroupChat:
            if (groupChatId) {
                path = groupChatPrivateCode
                    ? "/interaction/dialogs/".concat(groupChatId, "?dialog_code=").concat(groupChatPrivateCode)
                    : "/interaction/dialogs/".concat(groupChatId);
            }
            else {
                path = '/group-chats';
            }
            break;
        case LeadTypeEnum.SingleChat:
            if (ambassadorId) {
                if (isAutorized) {
                    path = "/interaction/".concat(ambassadorId);
                }
                else {
                    action = 'startRegistration';
                    path = '/';
                }
            }
            else {
                path = '/chat-to-us';
            }
            break;
        default:
            path = '/';
    }
    return { path: path, action: action };
};
